import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { TgglClient } from 'tggl-client';
import { useLocalization } from '~/composables/_next/useLocalization';
import { randomId } from '~/helpers/randomId';
import { isAuthorizedLanguage } from '~/i18n.config';
var pollingInterval = 30000; // 30 seconds

var initialFlags = {};
var tggleFlagsAndClientsKey = function tggleFlagsAndClientsKey(context) {
  return "".concat(context.country, "-").concat(context.locale);
};
function createServerTgglClient(_x, _x2, _x3) {
  return _createServerTgglClient.apply(this, arguments);
}
function _createServerTgglClient() {
  _createServerTgglClient = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(tgglKey, proxyUrl, context) {
    var client;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          client = new TgglClient(tgglKey, {
            url: proxyUrl
          });
          client.disableReporting();
          client.onResultChange(function (flags) {
            initialFlags[tggleFlagsAndClientsKey(context)] = flags;
          });
          client.onFetchFail(function (error) {
            console.error('Failed to fetch flags', error);
          });
          _context2.next = 6;
          return client.setContext(_objectSpread({
            environment: process.env.CURRENT_ENV
          }, context));
        case 6:
          return _context2.abrupt("return", client);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createServerTgglClient.apply(this, arguments);
}
var cachedCountryCodes = ['fr', 'it'];
var clients = {};
export default defineNuxtPlugin(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(nuxtApp) {
    var $config, _useLocalization, locale, country, tgglKey, tgglProxyUrl, proxyUrl, initialFlagsState, uuid, context, flagAndClientKey, serverClient, client;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          $config = nuxtApp.nuxt2Context.$config;
          _useLocalization = useLocalization(), locale = _useLocalization.locale, country = _useLocalization.country;
          tgglKey = $config.tgglKey, tgglProxyUrl = $config.tgglProxyUrl;
          proxyUrl = "".concat(tgglProxyUrl, "/flags");
          if (tgglKey) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          initialFlagsState = useState('initialFlags');
          uuid = randomId();
          context = {
            country: country,
            locale: locale.toLowerCase(),
            userId: uuid,
            time: Date.now()
          };
          flagAndClientKey = tggleFlagsAndClientsKey(context);
          if (!process.server) {
            _context.next = 23;
            break;
          }
          if (!(!clients[flagAndClientKey] && cachedCountryCodes.includes(context.country) && isAuthorizedLanguage(context.locale))) {
            _context.next = 16;
            break;
          }
          _context.next = 14;
          return createServerTgglClient(tgglKey, proxyUrl, context);
        case 14:
          clients[flagAndClientKey] = _context.sent;
          clients[flagAndClientKey].startPolling(pollingInterval);
        case 16:
          serverClient = clients[flagAndClientKey];
          if (serverClient) {
            _context.next = 21;
            break;
          }
          _context.next = 20;
          return createServerTgglClient(tgglKey, proxyUrl, context);
        case 20:
          serverClient = _context.sent;
        case 21:
          initialFlagsState.value = serverClient.getActiveFlags();
          return _context.abrupt("return", {
            provide: {
              flag: serverClient
            }
          });
        case 23:
          client = new TgglClient(tgglKey, {
            url: proxyUrl,
            initialActiveFlags: initialFlagsState.value
          }); // track('Flags Updated', initialFlagsState.value);
          client.onResultChange(function (flags) {
            initialFlagsState.value = flags;
            // track('Flags Updated', flags);
          });
          return _context.abrupt("return", {
            provide: {
              flag: client
            }
          });
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x4) {
    return _ref.apply(this, arguments);
  };
}());